import moment from 'moment'

function formatDate(date, format) {
  let dateFormatted = date
  if (format && date) {
    dateFormatted = moment(date).locale('es').format(format)
  }
  return dateFormatted
}

export function getDatesDifferenceSimple(startDate, endDate = new Date()) {
  if (startDate) {
    let durationResult = 0
    let symbol = 'días'
    const currentDate = moment(endDate)
    const date = moment(startDate)
    const duration = moment.duration(currentDate.diff(date))
    durationResult = parseInt(duration.asDays())
    if (durationResult === 0) {
      durationResult = parseInt(duration.asHours())
      symbol = 'horas'
    }
    if (durationResult === 0) {
      durationResult = parseInt(duration.asMinutes())
      symbol = 'minutos'
    }
    if (durationResult === 0) {
      durationResult = parseInt(duration.asSeconds())
      symbol = 'segundos'
    }
    if (Math.abs(durationResult) === 1) {
      symbol = symbol.slice(0, symbol.length - 1)
    }
    return `${Math.abs(durationResult)} ${symbol}`
  }
}

export function dateHourFormat(date) {
  return formatDate(date, 'HH:mm')
}

export function toLowerCase(data) {
  let result = ''
  if (data && typeof data === 'string') {
    result = data.toLowerCase()
  }
  return result
}
